export function MouseGradient() {
  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-10 h-px bg-white/10"
      style={{
        boxShadow: "0 1px 40px rgba(253, 149, 79, 0.06)",
      }}
      aria-hidden="true"
    />
  );
}
